import type { EnrollCourse201OneOfFiveResult } from './enrollCourse201OneOfFiveResult';

export type EnrollCourse201OneOfFive = {
  /**
   * 예상 수강 가능 일자
   * @nullable
   */
  estimatedAvailableDate?: string | null;
  /**
   * 대기열 순번
   * @minimum 1
   */
  position: number;
  result: EnrollCourse201OneOfFiveResult;
};
